import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { currentEetRegion } from '@stores/geographicAreaSlice';
import { GetJson } from '@awp/helpers/fetchReact';
import { REST_API, STATE_STATUS } from '@awp/constants';
import { format as formatDate } from 'date-fns';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import { endOfDay, endOfToday } from 'date-fns';

const initialState = {
  dashboardViews: null,
  endDate: Date.now(),
  displayDay: { value: '4', label: '4 days' },
  displayDays: [
    { value: '4', label: '4 days' },
    { value: '7', label: '7 days' },
    { value: '14', label: '14 days' },
    { value: '28', label: '28 days' },
  ],
  elasticMinute: { value: '15', label: '15 mins' },
  elasticMinutes: [
    { value: '15', label: '15 mins' },
    { value: '30', label: '30 mins' },
    { value: '60', label: '60 mins' },
  ],
  status: STATE_STATUS.IDLE, //this is the fetch status
  programs: [],
  program: null,
  programStatus: STATE_STATUS.IDLE,
  programError: null,
};
export const currentDashboardViews = (state) => state.avalancheDashboardViewPage.dashboardViews;
export const currentDisplayDay = (state) =>
  currentDisplayDays(state).find((d) => d.value == state.avalancheDashboardViewPage.displayDay.value);
export const currentEndDate = (state) => state.avalancheDashboardViewPage.endDate;
export const currentDisplayDays = (state) => state.avalancheDashboardViewPage.displayDays;
export const currentElasticMinute = (state) =>
  currentElasticMinutes(state).find((d) => d.value == state.avalancheDashboardViewPage.elasticMinute.value);
export const currentElasticMinutes = (state) => state.avalancheDashboardViewPage.elasticMinutes;

export const selectAllPrograms = (state) => state.avalancheDashboardViewPage.programs;
export const currentProgram = (state) => selectAllPrograms(state).find((rg) => rg.Id == currentProgramId(state));
export const currentProgramId = (state) => Number.parseInt(state.avalancheDashboardViewPage.program, 10);
export const getProgramLoadingStatus = (state) => state.avalancheDashboardViewPage.programStatus;

export const fetchDashboardViews = createAsyncThunk(
  'avalancheDashboardViewPage/fetchDashboardViews',
  async (args, { getState }) => {
    const st = getState();
    const avalancheDashboardViewPage = st.avalancheDashboardViewPage;
    const edt = formatDate(new Date(avalancheDashboardViewPage.endDate), 'yyyy-MM-dd-HH-mm-ss');
    let url = REST_API.AVA_DASHBOARD_VIEWS;
    url += `${avalancheDashboardViewPage.displayDay.value}/${edt}/${avalancheDashboardViewPage.program}`;
    const res = await GetJson(url);
    return await res.json();
  },
  {
    condition: (args, { getState }) => {
      const st = getState();
      const { avalancheDashboardViewPage: state } = st;
      console.log(state);
      return (
        !isValueEmpty(state) &&
        !isValueEmpty(state.program) &&
        !isValueEmpty(state.displayDays) &&
        //&& !isValueEmpty(state.elasticMinutes)
        !isValueEmpty(state.endDate)
      );
    },
  },
);
export const fetchPrograms = createAsyncThunk(
  'avalancheDashboardViewPage/fetchPrograms',
  async () => {
    const url = REST_API.AVA_MONITOR_PROGRAMS;
    return GetJson(url).then((response) => response.json());
  },
  {
    condition: (args, { getState }) => {
      const { avalancheDashboardViewPage: state } = getState();
      console.log(state.programStatus);
      //Load regions are not loaded
      return state.programStatus !== STATE_STATUS.LOADING;
    },
  },
);
export const avalancheDashboardViewPageSlice = createSlice({
  name: 'avalancheDashboardViewPage',
  initialState,
  reducers: {
    setDashboardViews(state, action) {
      return { ...state, dashboardViews: action.payload };
    },
    setEndDate(state, action) {
      return { ...state, endDate: action.payload };
    },
    setDisplayDay(state, action) {
      return { ...state, displayDay: action.payload };
    },
    setDisplayDays(state, action) {
      return { ...state, displayDays: action.payload };
    },
    setElasticMinute(state, action) {
      return { ...state, elasticMinute: action.payload };
    },
    setElasticMinutes(state, action) {
      return { ...state, elasticMinutes: action.payload };
    },
    setProgram(state, action) {
      return { ...state, program: action.payload };
    },
  },
  extraReducers: {
    [fetchDashboardViews.pending]: (state) => {
      state.status = STATE_STATUS.LOADING;
    },
    [fetchDashboardViews.fulfilled]: (state, action) => {
      state.status = STATE_STATUS.SUCCESS;
      state.dashboardViews = action.payload;
    },
    [fetchDashboardViews.rejected]: (state, action) => {
      state.status = STATE_STATUS.FAILED;
      state.error = action.error.message;
    },
    [fetchPrograms.pending]: (state) => {
      state.programStatus = STATE_STATUS.LOADING;
    },
    [fetchPrograms.fulfilled]: (state, action) => {
      state.programStatus = STATE_STATUS.SUCCESS;
      state.programs = action.payload;
    },
    [fetchPrograms.rejected]: (state, action) => {
      state.programStatus = STATE_STATUS.FAILED;
      state.programError = action.error.message;
    },
  },
});

export const {
  setEndDate,
  setDisplayDay,
  setDisplayDays,
  setElasticMinute,
  setElasticMinutes,
  setRegionId,
  setDashboardViews,
  setProgram,
} = avalancheDashboardViewPageSlice.actions;
